import React from 'react';
import style from './Container.module.scss';
import { cn } from '@/lib/utils';

export const Container = ({ children }: { children: React.ReactNode }) => {
  return <div className={cn(style.container, 'w-full')}>{children}</div>;
};
